const INITIAL_STATE = [];

export default function user(state = INITIAL_STATE, { type, payload }) {

    switch (type) {
        case 'data-load_FULFILLED': {
            if (payload && payload.key === 'dashboard') {
                return {
                    ...state,
                    ...payload.response.data,
                }
            }

            if (payload && payload.key === 'userLaod') {
                return {
                    ...state,
                    ...payload.response.data,
                }
            }
            return state;
        }

        case 'login_FULFILLED': {
            if (payload && type === 'login_FULFILLED') {
                return {
                    ...payload.data.data,
                }
            }

            return state;
        }

        case 'app/reset': {
            return INITIAL_STATE;
        }
        case 'UPDATE_USER':
            return {
                ...state,
                ...payload,
            };

        default:
            return state;
    }
}
